import { getGraphqlClient } from "@/api/graphql/client";
import { BillingMsGetAccountsLinkableToTidRequestSortField } from "@/api/graphql/types/graphql";

import { getAccountsLinkableToTidQuery } from "./queries";
import type { GetAccountsLinkableToTidParams } from "./types";

export const getAccountsLinkableToTid = async ({
  query,
  targetAccountId,
}: GetAccountsLinkableToTidParams) => {
  const graphqlClient = getGraphqlClient();

  const response = await graphqlClient.request(getAccountsLinkableToTidQuery, {
    request: {
      filters: {
        query,
        targetAccountId,
      },
      sorts: [
        {
          ascending: true,
          field: BillingMsGetAccountsLinkableToTidRequestSortField.Name,
        },
      ],
    },
  });

  return {
    data: response.BillingMsGetAccountsLinkableToTid.data ?? [],
    pagination: response.BillingMsGetAccountsLinkableToTid.pagination,
  };
};
